import React, { Component } from 'react';
import Map from "./Map";
import './App.css';

function App() {
  return (
    <div className='tc'>
		 <h1 className='f1'>International Space Station Current Location</h1>
		 
		 <div className='f1' id="MAP">
		 <Map />
		 <div id="container">
    	<img src="https://raw.githubusercontent.com/hrvoje-rama/iss-tracker/edebed0d83f1b97a893dd7ce5717c1519d8a8df5/src/rocket.svg"/>
		</div>
		 </div>
		</div>
  );
}

export default App;